import { C } from "../constants";
import { Logo } from "./UI";
import { useState } from "react";

export function UpgradeModal({ reason, onClose, onUpgrade }) {
  const [promoCode, setPromoCode] = useState("");
  const [promoState, setPromoState] = useState(null);
  const [promoLoading, setPromoLoading] = useState(false);

  const validatePromo = async (code, plan) => {
    if (!code.trim()) return;
    setPromoLoading(true);
    setPromoState(null);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/validate-promo`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ code: code.trim().toUpperCase(), plan }),
      });
      const data = await res.json();
      if (data.valid) {
        setPromoState({ valid: true, promoId: data.promoId, discount: data.discount, description: data.description, plan });
      } else {
        setPromoState({ valid: false, error: data.error || "Invalid promo code" });
      }
    } catch {
      setPromoState({ valid: false, error: "Could not validate code" });
    }
    setPromoLoading(false);
  };

  const handlePlanClick = (plan) => {
    onClose();
    const promoId = promoState?.valid && promoState.plan === plan ? promoState.promoId : null;
    onUpgrade(plan, promoId);
  };

  const plans = [
    { plan:"pack", name:"Match Pack", price:"$9.99", period:"One-time", features:["5 Job Matches","5 Resume Tailors","5 AI Resume Builds","ATS Score Checker + Fix My Gaps","Resume Strength Score","Cover Letter Generator","Interview Prep Questions","LinkedIn Rewriter","PDF & Word Downloads","Job Tracker"], cta:"Get Match Pack", color:C.teal, highlight:false },
    { plan:"pro", name:"Pro Matcher", price:"$24.99", period:"Per Month", features:["Unlimited Searches","Unlimited Tailoring","Unlimited AI Resume Builds","PDF & Word Downloads","ATS Score Checker + Fix My Gaps","Resume Strength Score","Cover Letter Generator","Interview Prep Questions","LinkedIn Rewriter","Job Tracker","Priority Support"], cta:"Get Pro Matcher", color:C.accent, highlight:true },
  ];

  return (
    <div style={{ position:"fixed", top:0, left:0, right:0, bottom:0, background:"rgba(0,0,0,0.8)", backdropFilter:"blur(8px)", zIndex:200, display:"flex", alignItems:"center", justifyContent:"center", padding:24 }}>
      <div style={{ background:"#ffffff", border:`1px solid ${C.border}`, borderRadius:22, padding:"36px 30px", maxWidth:720, width:"100%", position:"relative", maxHeight:"90vh", overflowY:"auto" }}>
        <button onClick={onClose} style={{ position:"absolute", top:16, right:18, background:"transparent", border:"none", color:C.muted, fontSize:22, cursor:"pointer" }}>×</button>
        <div style={{ textAlign:"center", marginBottom:24 }}>
          <h2 style={{ margin:"0 0 8px", fontSize:22, fontWeight:700, letterSpacing:"-0.02em" }}>Choose your plan</h2>
          <p style={{ color:C.sub, fontSize:13, margin:"0 0 12px", lineHeight:1.6 }}>Upgrade to find and land your perfect role faster</p>
          <div style={{ display:"inline-flex", alignItems:"center", gap:8 }}>
            <span style={{ background:"transparent", border:`1.5px solid ${C.teal}`, color:C.teal, borderRadius:6, padding:"2px 10px", fontSize:12, fontWeight:700, fontFamily:"'Space Mono',monospace", letterSpacing:1 }}>LAUNCH25</span>
            <span style={{ fontSize:13, color:C.sub }}>— 25% off Pro your first month</span>
          </div>
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:20, maxWidth:640, margin:"0 auto 20px" }}>
          {plans.map(p => (
            <div key={p.name} style={{ background: p.highlight ? "#fff5f5" : "#f9fafb", border:`1.5px solid ${p.highlight ? C.accent+"70" : C.teal+"60"}`, borderRadius:16, padding:"22px 20px", position:"relative" }}>
              {p.highlight && (
                <div style={{ position:"absolute", top:-13, left:"50%", transform:"translateX(-50%)", background:`linear-gradient(135deg,${C.accent},#c0392b)`, color:"#fff", fontSize:11, fontWeight:700, borderRadius:20, padding:"3px 14px", whiteSpace:"nowrap" }}>Most popular</div>
              )}
              <div style={{ fontWeight:700, fontSize:15, marginBottom:4 }}>{p.name}</div>
              <div style={{ fontSize:26, fontWeight:700, fontFamily:"'Space Mono',monospace", color:p.color, marginBottom:2 }}>
                {p.price}
              </div>
              <div style={{ fontSize:12, color:C.muted, marginBottom:16 }}>{p.period}</div>
              {p.features.map(f => (
                <div key={f} style={{ fontSize:13, color:"#374151", marginBottom:7, display:"flex", gap:8, alignItems:"flex-start" }}>
                  <span style={{ color:p.color, fontWeight:700, flexShrink:0 }}>✓</span>{f}
                </div>
              ))}
              <button onClick={() => handlePlanClick(p.plan)}
                style={{ marginTop:18, width:"100%", background: p.highlight ? `linear-gradient(135deg,${C.accent},#c0392b)` : C.teal, color: p.highlight ? "#fff" : "#0b0c12", border:"none", borderRadius:10, padding:"11px 0", fontSize:14, fontWeight:700, cursor:"pointer" }}>
                {p.cta}
              </button>
            </div>
          ))}
        </div>
        <div style={{ maxWidth:640, margin:"0 auto", marginBottom:14 }}>
          <div style={{ display:"flex", gap:8, alignItems:"center" }}>
            <input
              value={promoCode}
              onChange={e => { setPromoCode(e.target.value); setPromoState(null); }}
              placeholder="Promo code (optional)"
              style={{ flex:1, border:`1.5px solid ${promoState?.valid ? C.teal : promoState?.valid === false ? "#e74c3c" : C.border}`, borderRadius:8, padding:"9px 12px", fontSize:13, fontFamily:"'DM Sans',sans-serif", outline:"none" }}
            />
            <button
              onClick={() => validatePromo(promoCode, "pro")}
              disabled={promoLoading || !promoCode.trim()}
              style={{ background:C.teal, color:"#0b0c12", border:"none", borderRadius:8, padding:"9px 16px", fontSize:13, fontWeight:700, cursor:"pointer", opacity: promoLoading || !promoCode.trim() ? 0.5 : 1 }}>
              {promoLoading ? "..." : "Apply"}
            </button>
          </div>
          {promoState?.valid && (
            <div style={{ marginTop:6, fontSize:12, color:C.teal, fontWeight:600 }}>✓ {promoState.description} — click your plan to apply</div>
          )}
          {promoState?.valid === false && (
            <div style={{ marginTop:6, fontSize:12, color:"#e74c3c" }}>✗ {promoState.error}</div>
          )}
        </div>
        <p style={{ textAlign:"center", color:C.muted, fontSize:11, fontFamily:"'Space Mono',monospace", margin:0 }}>
          Free tier: 5 searches/mo · 1 tailor/mo · 1 AI Resume Build · Save Job Matches
        </p>
      </div>
    </div>
  );
}

export function HowItWorksModal({ onClose }) {
  const steps = [
    { icon:"📄", num:"01", title:"Share Your Resume", body:"Drop your resume and our AI reads your full career story — skills, experience, roles, and achievements. No forms to fill out." },
    { icon:"🔍", num:"02", title:"We Search for Your Match", body:"Like a matchmaker, we scour thousands of live job postings across Indeed, LinkedIn, Greenhouse, and company career pages — ranking each one by how well it fits YOU." },
    { icon:"💘", num:"03", title:"Meet Your Matches", body:"Browse jobs ranked by compatibility score. Save the ones that catch your eye, and ignore the rest. No more scrolling through jobs that were never right for you." },
    { icon:"✍️", num:"04", title:"Tailor Your Resume to the Role", body:"Found the one? We rewrite your resume to speak directly to that job — highlighting the right experience and keywords to make a great first impression." },
    { icon:"🚀", num:"05", title:"Apply with Confidence", body:"Hit Apply and we take you straight to the official listing. You apply on their site directly — we just make sure you show up at your best." },
  ];
  return (
    <div style={{ position:"fixed", top:0, left:0, right:0, bottom:0, background:"rgba(0,0,0,0.82)", backdropFilter:"blur(8px)", zIndex:200, display:"flex", alignItems:"center", justifyContent:"center", padding:24 }} onClick={onClose}>
      <div style={{ background:"#ffffff", border:`1px solid ${C.border}`, borderRadius:22, padding:"36px 30px", maxWidth:540, width:"100%", position:"relative", maxHeight:"88vh", overflowY:"auto" }} onClick={e => e.stopPropagation()}>
        <button onClick={onClose} style={{ position:"absolute", top:16, right:18, background:"transparent", border:"none", color:C.muted, fontSize:22, cursor:"pointer" }}>×</button>
        <div style={{ marginBottom:28 }}>
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:14 }}>
            <Logo size={34}/>
            <span style={{ fontFamily:"'Playfair Display',serif", fontWeight:700, fontSize:22, letterSpacing:"-0.01em" }}>
              get<span style={{ color:C.accent }}>resu</span>match.com
            </span>
          </div>
          <h2 style={{ margin:"0 0 8px", fontSize:22, fontWeight:700, letterSpacing:"-0.02em" }}>How the Matchmaking Works</h2>
          <p style={{ color:C.sub, fontSize:13, margin:0, lineHeight:1.6 }}>Think of us as a career matchmaker — we do the searching, the comparing, and the tailoring, so you can focus on the interview.</p>
        </div>
        <div style={{ display:"flex", flexDirection:"column" }}>
          {steps.map((s, i) => (
            <div key={s.num} style={{ display:"flex", gap:16, paddingBottom: i < steps.length-1 ? 26 : 0, position:"relative" }}>
              {i < steps.length-1 && (
                <div style={{ position:"absolute", left:19, top:42, width:2, height:"calc(100% - 14px)", background:`linear-gradient(to bottom,${C.accent}50,transparent)` }}/>
              )}
              <div style={{ flexShrink:0, width:40, height:40, borderRadius:12, background:C.accentSoft, border:`1.5px solid ${C.accent}50`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:17, zIndex:1 }}>
                {s.icon}
              </div>
              <div style={{ paddingTop:7 }}>
                <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:5 }}>
                  <span style={{ fontFamily:"'Space Mono',monospace", fontSize:10, color:C.accent }}>{s.num}</span>
                  <span style={{ fontWeight:700, fontSize:14 }}>{s.title}</span>
                </div>
                <p style={{ color:C.sub, fontSize:13, margin:0, lineHeight:1.65 }}>{s.body}</p>
              </div>
            </div>
          ))}
        </div>
        <div style={{ marginTop:26, padding:"14px 18px", background:"rgba(34,211,184,0.06)", border:`1px solid ${C.teal}30`, borderRadius:12 }}>
          <div style={{ fontSize:12, color:C.teal, fontWeight:700, marginBottom:4 }}>🔒 Your resume stays yours</div>
          <p style={{ fontSize:12, color:C.sub, margin:0, lineHeight:1.6 }}>We never share your resume with employers or third parties. It's only ever used to find and tailor your matches.</p>
        </div>
        <button onClick={onClose} style={{ marginTop:18, width:"100%", background:`linear-gradient(135deg,${C.accent},#c0392b)`, color:"#fff", border:"none", borderRadius:10, padding:"12px 0", fontSize:14, fontWeight:700, cursor:"pointer", letterSpacing:"-0.01em" }}>
          Find My Matches →
        </button>
      </div>
    </div>
  );
}
